import type {OperationStateDto} from '@devmil/contracts';

const ENVIRONMENT_LABEL: Record<OperationStateDto['environment'], string> = {
  production: 'PRODUÇÃO',
  staging: 'HOMOLOGAÇÃO',
};

const CONNECTION_LABEL: Record<OperationStateDto['connection'], string> = {
  connected: 'Meta conectada',
  disconnected: 'Meta desconectada',
  reauth_required: 'Reautenticação necessária',
};

export const EnvironmentStatus = ({
  operation,
}: {
  operation: OperationStateDto;
}) => (
  <div className="dm-topbar-meta">
    <span className="dm-env">{ENVIRONMENT_LABEL[operation.environment]}</span>
    <span
      className={operation.paused ? 'dm-connection is-paused' : 'dm-connection'}
    >
      <span aria-hidden="true">●</span>{' '}
      <span>
        {operation.paused
          ? 'Operação pausada'
          : CONNECTION_LABEL[operation.connection]}
      </span>
    </span>
  </div>
);
